import type { ShippingRecord } from './shipping-types'
import { apiConfig } from "./client";

export const shippingApi = {
  list: async (from: number, to: number, signal?: AbortSignal) => {
    const response = await apiConfig.get<ShippingRecord[]>(
      `/api/front/chef/chef-report/${from}/${to}`,
      { signal }
    );
    return response;
  },
};
